import { Checkbox, Col, Collapse, ConfigProvider, Row } from "antd";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../apis/store";
import OrphanAvatar from "../../../../../biblio/Cards/OrphanAvatar";
import Inputs from "../../../../../biblio/Inputs/Inputs";
import Selects from "../../../../../biblio/Selects/Selects";
import TagComponent from "../../../../../biblio/TagComponent";
import { avatarDetails } from "../../../../../data/OrphansData";
import { disabledDate } from "../utils";
import InputDate from "../../../../../biblio/Inputs/InputDate";
import ar_EG from "antd/lib/locale/ar_EG";

interface Props {
  selectedItems: any[];
  addOrRemoveItem: (n: any[]) => void;
  setSelctedItems: any;
  itemPerPage: number;
  currentPage: number;
  type: "sponsored" | "unsponsored";
  surplus_amount?: any;
}
const EditUnsponsoredOrphansCollapse = ({
  selectedItems,
  addOrRemoveItem,
  setSelctedItems,
  itemPerPage,
  currentPage,
  type,
  surplus_amount,
}: Props) => {
  const { t } = useTranslation();
  const startIndex = (currentPage - 1) * itemPerPage;

  const onSelectChange = (e: any, id: number) => {
    const l__updatedOrphans = [...selectedItems];
    // eslint-disable-next-line eqeqeq
    const index = type =="sponsored" ? id :l__updatedOrphans.findIndex((item) => item.id === id);
    const sponsorshipAmount = getSponsorshipAmount(e?.key);
    l__updatedOrphans[index] = {
        ...l__updatedOrphans[index],
        sponnsorShipAmount: sponsorshipAmount,
        selectedSponsorShipType: e,
        amount: sponsorshipAmount * l__updatedOrphans[index].month,
    };
    setSelctedItems(l__updatedOrphans);
};
  const onMonthChange = (e: any, id: number) => {
    const l__updatedOrphans = [...selectedItems];
    // eslint-disable-next-line eqeqeq
    const index = type =="sponsored" ? id :l__updatedOrphans.findIndex((el) => el.id === id);
    const newMounth =
      e.target.value === "" ? "" : Math.min(60, Math.max(1, e.target.value));
    if (l__updatedOrphans[index]?.month > newMounth && type === "unsponsored") {
      l__updatedOrphans[index].month = newMounth;
      l__updatedOrphans[index].amount =
        Number(newMounth) * l__updatedOrphans[index]?.sponnsorShipAmount;
      setSelctedItems(l__updatedOrphans);
    }
    /*
    if (surplus_amount < 200 && type === "unsponsored") {
      l__updatedOrphans[index].month = newMounth;
      l__updatedOrphans[index].amount =
        Number(newMounth) * l__updatedOrphans[index]?.sponnsorShipAmount;
      setSelctedItems(l__updatedOrphans);
    }
    if (
      type === "unsponsored" &&
      selectedItems.reduce((a, b) => b.amount + a, 0) +
        l__updatedOrphans[index]?.sponnsorShipAmount <
        surplus_amount + 1
    ) {
      l__updatedOrphans[index].month = newMounth;
      l__updatedOrphans[index].amount =
        Number(newMounth) * l__updatedOrphans[index]?.sponnsorShipAmount;
      setSelctedItems(l__updatedOrphans);
    } else if (type === "sponsored") {
      l__updatedOrphans[index].month = newMounth;
      l__updatedOrphans[index].amount =
        Number(newMounth) * l__updatedOrphans[index]?.sponnsorShipAmount;
      setSelctedItems(l__updatedOrphans);
    }
    */
    l__updatedOrphans[index].month = newMounth;
    l__updatedOrphans[index].amount =
      Number(newMounth) * l__updatedOrphans[index]?.sponnsorShipAmount;
    setSelctedItems(l__updatedOrphans);
  };
  const onDateChange = (e: any, id: number) => {
    const l__updatedOrphans = [...selectedItems];
    const index = l__updatedOrphans.findIndex((el) => el.id === id);
    if (e) {
    l__updatedOrphans[index].sponsorship_start_date = e;
    }
    setSelctedItems(l__updatedOrphans);
  };
  const verifyChecked = (id: number) => {
    const index = selectedItems.findIndex((i: any) => i.id === id);
    if (index !== -1) return true;
    return false;
  };
  const { sponsorshipAmount } = useSelector(
    (state: RootState) => state?.sponsor
  );
  const getSponsorshipAmount = (id: number) => {
    switch (id) {
      case 4:
        return sponsorshipAmount.widow_sponsorship_amount;
      case 2:
        return sponsorshipAmount.main_sponsorship_amount;
      case 1:
        return sponsorshipAmount.support_sponsorship_amount;
      case 3:
        return (
          sponsorshipAmount.support_sponsorship_amount +
          sponsorshipAmount.main_sponsorship_amount
        );

      default:
        return 0;
    }
  };
  return (
    <Collapse
      style={{ margin: "2rem 0" }}
      className={`takaful--collapse-profile takaful--collapse-beneficiary-services takaful--collapse-sponsor-requests`}
      accordion
    >
      {selectedItems
        ?.slice(startIndex, startIndex + itemPerPage)
        ?.map((element: any, index: number) => (
          <Collapse.Panel
            key={element.id}
            showArrow={false}
            className="takaful--header-profile-Panel takaful--services-panel takaful--collapse-label-panel"
            header={
              <div className="takaful--header-profile-container">
                <Row
                  justify={"space-between"}
                  className="takaful--content-profile-box1"
                  style={{ marginBottom: "0", width: "100%" }}
                  key={element.id}
                  gutter={8}
                >
                  <Col
                    xxl={1}
                    xl={1}
                    lg={1}
                    md={1}
                    sm={2}
                    xs={2}
                    className="takaful--unsponsored-orphan-container takaful--unsponsored-orphan-col"
                  >
                    <Checkbox
                      checked={verifyChecked(element.id)}
                      onClick={(e) => e.stopPropagation()}
                      onChange={() => addOrRemoveItem(element)}
                    />
                  </Col>
                  <Col
                    xxl={5}
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={type === "unsponsored" ? 17 : 22}
                  >
                    <OrphanAvatar
                      className="takaful--sponsor-orphan-avatar"
                      title={avatarDetails[element?.beneficiary_type]?.title}
                      urlImage={
                        avatarDetails[element?.beneficiary_type]?.urlImage
                      }
                      styleTitle={`takaful--${element?.beneficiary_type}-avatar`}
                      beneficiaryNumber={
                        type === "sponsored"
                          ? element?.beneficiary_number
                          : element?.family_number
                      }
                      beneficiaryName={`${element?.firstname} ${element?.father_name}`}
                      type={type}
                    />
                  </Col>
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={0}
                    xs={type === "unsponsored" ? 0 : 4}
                  />
                  {type === "unsponsored" ? (
                    <ConfigProvider locale={ar_EG} direction="rtl">
                      <Col
                        xxl={3}
                        xl={3}
                        lg={3}
                        md={3}
                        sm={5}
                        xs={5}
                        className=" takaful--unsponsored-orphan-container takaful--unsponsored-orphan-col"
                      >
                        <span className="takaful--unsponsored-orphan-name">
                          {element?.age}
                        </span>
                      </Col>
                      <Col
                        xxl={4}
                        xl={5}
                        lg={5}
                        md={5}
                        sm={12}
                        xs={12}
                        className=" takaful--unsponsored-orphan-container takaful--unsponsored-orphan-col"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <Selects
                          options={
                            verifyChecked(element.id) ? element?.options : []
                          }
                          selectPlaceholder="اختر نوع الكفالة"
                          allowClear={true}
                          onChange={(e) => onSelectChange(e, element.id)}
                          value={
                            verifyChecked(element.id)
                              ? element.selectedSponsorShipType
                              : null
                          }
                          className="takaful--service-select takaful--unsponsored-orphan-select takaful--request-select"
                          popupClassName="takaful--service-select-dropdown"
                          disabled={
                            !verifyChecked(element.id) ||
                            element?.options.length === 1
                          }
                        />
                      </Col>
                      <Col
                        xxl={3}
                        xl={3}
                        lg={3}
                        md={3}
                        sm={12}
                        xs={12}
                        className="takaful--unsponsored-orphan-container takaful--unsponsored-orphan-col"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <Inputs
                          className="takaful--unsponsored-orphan-amount takaful--donation-input takaful--unsponsored-orphan-input"
                          max={60}
                          min={1}
                          type="number"
                          withArrow={true}
                          placeholder="عدد الأشهر"
                          key={element.id}
                          disabled={!verifyChecked(element.id)}
                          value={
                            verifyChecked(element.id) ? element.month : null
                          }
                          onChange={(e) => onMonthChange(e, element?.id)}
                        />
                      </Col>
                      <Col
                        xxl={3}
                        xl={3}
                        lg={3}
                        md={3}
                        sm={12}
                        xs={12}
                        className=" takaful--unsponsored-orphan-container takaful--unsponsored-orphan-col"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <InputDate
                        allowClear={false}
                          class="takaful--input-date-container-class"
                          disabled={!verifyChecked(element.id)}
                          className="takaful--unsponsored-input-start-date"
                          placeholder="اختر بداية الشهر"
                          disabledDate={disabledDate}
                          value={
                            verifyChecked(element?.id)
                              ? element?.sponsorship_start_date
                              : null
                          }
                          onChange={(e) => onDateChange(e, element.id)}
                        />
                      </Col>
                      <Col
                        xxl={3}
                        xl={3}
                        lg={3}
                        md={3}
                        sm={12}
                        xs={12}
                        className=" takaful--unsponsored-orphan-container takaful--unsponsored-orphan-col"
                      >
                        <div
                          className={`takaful--unsponsored-orphan-amount  ${
                            verifyChecked(element.id)
                              ? ""
                              : "takaful--unsponsored-orphan-amount-disabled"
                          }`}
                          style={{
                            padding: verifyChecked(element.id)
                              ? ""
                              : "0.6rem 0",
                          }}
                        >
                          <p>
                            {verifyChecked(element.id) ? element.amount : ""}
                          </p>
                          <span className="icon-saudi_riyal"></span>
                        </div>
                      </Col>
                    </ConfigProvider>
                  ) : (
                    <>
                      <Col
                        xxl={3}
                        xl={3}
                        lg={3}
                        md={3}
                        sm={4}
                        xs={8}
                        className=" takaful--unsponsored-orphan-container takaful--unsponsored-orphan-col"
                      >
                        <span className="takaful--unsponsored-orphan-name">
                          {element?.firstname} {element?.father_name}
                        </span>
                      </Col>
                      <Col
                        xxl={4}
                        xl={3}
                        lg={3}
                        md={3}
                        sm={4}
                        xs={12}
                        className=" takaful--unsponsored-orphan-container takaful--unsponsored-orphan-col"
                      >
                        <span className="takaful--unsponsored-orphan-name">
                          {element?.age}
                        </span>
                      </Col>
                      <Col
                        xxl={4}
                        xl={5}
                        lg={5}
                        md={5}
                        sm={10}
                        xs={24}
                        className=" takaful--unsponsored-orphan-container takaful--unsponsored-orphan-col"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <Selects
                          options={
                            verifyChecked(element.id) ? element?.options : []
                          }
                          selectPlaceholder="اختر نوع الكفالة"
                          allowClear={true}
                          onChange={(e) => onSelectChange(e, index)}
                          value={
                            verifyChecked(element.id)
                              ? element.selectedSponsorShipType
                              : null
                          }
                          className="takaful--service-select takaful--unsponsored-orphan-select takaful--request-select"
                          popupClassName="takaful--service-select-dropdown"
                          disabled={
                            !verifyChecked(element.id) ||
                            element?.options.length === 1
                          }
                        />
                      </Col>
                      <Col
                        xxl={3}
                        xl={3}
                        lg={3}
                        md={3}
                        sm={6}
                        xs={12}
                        className="takaful--unsponsored-orphan-container takaful--unsponsored-orphan-col"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <Inputs
                          className="takaful--unsponsored-orphan-amount takaful--donation-input takaful--unsponsored-orphan-input"
                          type="number"
                          withArrow={true}
                          placeholder="عدد الأشهر"
                          key={element.id}
                          disabled={!verifyChecked(element.id)}
                          value={
                            verifyChecked(element.id) ? element.month : null
                          }
                          onChange={(e) => onMonthChange(e, index)}
                          maxLength={60}
                        />
                      </Col>
                      <Col
                        xxl={3}
                        xl={3}
                        lg={3}
                        md={3}
                        sm={8}
                        xs={12}
                        className=" takaful--unsponsored-orphan-container takaful--unsponsored-orphan-col"
                      >
                        <div
                          className={`takaful--unsponsored-orphan-amount  ${
                            verifyChecked(element.id)
                              ? ""
                              : "takaful--unsponsored-orphan-amount-disabled"
                          }`}
                        >
                          <p>
                            {verifyChecked(element.id) ? element.amount : ""}
                          </p>
                          <span className="icon-saudi_riyal"></span>
                        </div>
                      </Col>
                    </>
                  )}
                </Row>
              </div>
            }
          >
            <div style={{ padding: "0rem 1rem 1rem 2rem" }}>
              <Row
                className={`takaful--content-profile-box1`}
                style={{ textAlign: "center" }}
              >
                <Col
                  xxl={3}
                  xl={3}
                  lg={3}
                  md={3}
                  sm={0}
                  xs={0}
                  className="takaful--content-profile-col"
                />
                <Col
                  xxl={3}
                  xl={3}
                  lg={3}
                  md={3}
                  sm={12}
                  xs={12}
                  className="takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">الجنس</p>
                </Col>
                <Col
                  xxl={3}
                  xl={3}
                  lg={4}
                  md={4}
                  sm={12}
                  xs={12}
                  className="takaful--content-profile-col"
                >
                  <span className="takaful--content-services-request-span takaful--color-span">
                    {t(`gender.${element?.gender}`)}
                  </span>
                </Col>

                <Col
                  xxl={4}
                  xl={4}
                  lg={4}
                  md={4}
                  sm={12}
                  xs={13}
                  className="takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p takaful--label-p-responsive-design">
                    الحالة الصحية
                  </p>
                </Col>
                <Col
                  xxl={4}
                  xl={4}
                  lg={6}
                  md={6}
                  sm={12}
                  xs={11}
                  className="takaful--content-profile-col"
                >
                  <span className="takaful--content-services-request-span takaful--color-span">
                    {element?.health_state_id}
                  </span>
                </Col>
              </Row>
              <Row
                className={`takaful--content-profile-box1`}
                style={{ textAlign: "center" }}
              >
                <Col
                  xxl={3}
                  xl={3}
                  lg={3}
                  md={3}
                  sm={0}
                  xs={0}
                  className="takaful--content-profile-col"
                />
                <Col
                  xxl={3}
                  xl={3}
                  lg={3}
                  md={3}
                  sm={12}
                  xs={12}
                  className="takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">العمر</p>
                </Col>
                <Col
                  xxl={3}
                  xl={3}
                  lg={4}
                  md={4}
                  sm={12}
                  xs={12}
                  className="takaful--content-profile-col"
                >
                  <span className="takaful--content-services-request-span takaful--color-span">
                    {element?.age}
                  </span>
                </Col>

                <Col
                  xxl={4}
                  xl={4}
                  lg={4}
                  md={4}
                  sm={12}
                  xs={12}
                  className="takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">الجنسية</p>
                </Col>
                <Col
                  xxl={4}
                  xl={4}
                  lg={6}
                  md={6}
                  sm={12}
                  xs={12}
                  className="takaful--content-profile-col"
                >
                  <span className="takaful--content-services-request-span takaful--color-span">
                    {element?.nationality_id}
                  </span>
                </Col>
              </Row>
              {element.disease_type_ids.length > 0 && (
                <Row
                  className={`takaful--content-profile-box1`}
                  style={{ textAlign: "center" }}
                >
                  <Col
                    xxl={3}
                    xl={3}
                    lg={3}
                    md={3}
                    sm={0}
                    xs={0}
                    className="takaful--content-profile-col"
                  />
                  <Col
                    xxl={3}
                    xl={3}
                    lg={3}
                    md={3}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      الأمراض
                    </p>
                  </Col>
                  <Col
                    xxl={17}
                    xl={17}
                    lg={17}
                    md={17}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col "
                  >
                    <div
                      className=""
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        width: "100%",
                      }}
                    >
                      {element?.disease_type_ids?.map((item: any) => (
                        <TagComponent
                          className="takaful--tag-style"
                          state={element?.disbursement_status}
                          text={item.name}
                        />
                      ))}
                    </div>
                  </Col>
                </Row>
              )}
              {type === "sponsored" &&
                (["widow", "support", "main"].some(
                  (type) => element?.sponsorship_type === type
                ) ? (
                  element?.sponsorship_paid_to !== false && (
                    <Row
                      className={`takaful--content-profile-box1`}
                      style={{ textAlign: "center" }}
                    >
                      <Col
                        xxl={3}
                        xl={3}
                        lg={3}
                        md={3}
                        sm={0}
                        xs={0}
                        className="takaful--content-profile-col"
                      />
                      <Col
                        xxl={4}
                        xl={4}
                        lg={4}
                        md={4}
                        sm={12}
                        xs={12}
                        className="takaful--content-profile-col"
                      >
                        <p
                          className="takaful--content-services-request-p"
                          style={{
                            marginRight: "1vw",
                          }}
                        >
                          كفالة مدفوع إلى
                        </p>
                      </Col>
                      <Col
                        xxl={4}
                        xl={4}
                        lg={4}
                        md={4}
                        sm={12}
                        xs={12}
                        className="takaful--content-profile-col"
                      >
                        <span className="takaful--content-services-request-span takaful--color-span takaful--date-format">
                          {element?.sponsorship_paid_to}
                        </span>
                      </Col>
                    </Row>
                  )
                ) : (
                  <Row
                    className={`takaful--content-profile-box1`}
                    style={{ textAlign: "center" }}
                  >
                    {element?.main_sponsorship_paid_to !== false && (
                      <>
                        <Col
                          xxl={3}
                          xl={3}
                          lg={3}
                          md={3}
                          sm={0}
                          xs={0}
                          className="takaful--content-profile-col"
                        />
                        <Col
                          xxl={5}
                          xl={5}
                          lg={5}
                          md={5}
                          sm={12}
                          xs={12}
                          className="takaful--content-profile-col"
                        >
                          <p className="takaful--content-services-request-p">
                            كفالة رئيسية مدفوع إلى
                          </p>
                        </Col>
                        <Col
                          xxl={4}
                          xl={4}
                          lg={4}
                          md={4}
                          sm={12}
                          xs={12}
                          className="takaful--content-profile-col"
                        >
                          <span className="takaful--content-services-request-span takaful--color-span takaful--date-format">
                            {element?.main_sponsorship_paid_to}
                          </span>
                        </Col>
                      </>
                    )}
                    {element?.support_sponsorship_paid_to !== false && (
                      <>
                        <Col
                          xxl={
                            element?.main_sponsorship_paid_to === false ? 3 : 0
                          }
                          xl={
                            element?.main_sponsorship_paid_to === false ? 3 : 0
                          }
                          lg={
                            element?.main_sponsorship_paid_to === false ? 3 : 0
                          }
                          md={
                            element?.main_sponsorship_paid_to === false ? 3 : 0
                          }
                          sm={0}
                          xs={0}
                          className="takaful--content-profile-col"
                        />
                        <Col
                          xxl={5}
                          xl={5}
                          lg={5}
                          md={5}
                          sm={12}
                          xs={12}
                          className="takaful--content-profile-col"
                        >
                          <p
                            className="takaful--content-services-request-p"
                            style={{
                              marginLeft: "1.5vw",
                            }}
                          >
                            كفالة دعم مدفوع إلى
                          </p>
                        </Col>
                        <Col
                          xxl={4}
                          xl={4}
                          lg={4}
                          md={4}
                          sm={12}
                          xs={12}
                          className="takaful--content-profile-col"
                        >
                          <span className="takaful--content-services-request-span takaful--color-span takaful--date-format">
                            {element?.support_sponsorship_paid_to}
                          </span>
                        </Col>
                      </>
                    )}
                  </Row>
                ))}
            </div>
          </Collapse.Panel>
        ))}
    </Collapse>
  );
};

export default EditUnsponsoredOrphansCollapse;
